import { getZoomAnimation } from '../animations/zoom'

export function getTextScaleAnimation (element, settings) {
    // The element zoom fades by default; a text fragment does not, like the editor default.
    return {
        from: getZoomAnimation(element, { zoom: settings.zoom ?? 0, withFade: settings.withFade ?? false }),
    }
}
